import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import { LoggingService } from './shared/services/logging.service';
import LanguageService from './shared/services/language.service';
import LANGUAGES from './shared/constants/language.constants';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private loggingService: LoggingService,
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
    private languageService: LanguageService,
  ) {}

  title = 'talking-buddy-angular-portal';

  ngOnInit(): void {
    this.initializePrimeNgConfigs();
    this.initializeAppLanguage();
    try {
      this.loggingService.log(
        'SUCCESS',
        'HIGH',
        'LoginScreen',
        'LoginComponent.ngOnInit',
        'Initialize the login component',
        { additionalData: 'Example data' },
      );
      // Your logic...
    } catch (error) {
      this.loggingService.log(
        'ERROR',
        'HIGH',
        'LoginScreen',
        'LoginComponent.ngOnInit',
        'Failed to initialize the login component',
        { additionalData: 'Example data', error },
      );
    }
  }

  initializePrimeNgConfigs() {
    this.primengConfig.ripple = true;
  }

  initializeAppLanguage() {
    this.translateService.setDefaultLang(LANGUAGES.ENGLISH);
    const currentLanguage = this.languageService.getCurrentLanguage();
    this.translateService.use(currentLanguage.code || LANGUAGES.ENGLISH);
  }
}
